import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CidService {

  set(cid: string): void {
    sessionStorage.setItem('cid', cid);
  }

  get(): string {
    return sessionStorage.getItem('cid') || '';
  }
}
